{
  "2026-0": {
    "projects": [
      {
        "id": 1704467200001,
        "projectName": "E-Commerce Platform",
        "companyName": "TechCorp",
        "budget": 12500,
        "employeeCapacity": 3
      },
      {
        "id": 1704467200002,
        "projectName": "Mobile Banking App",
        "companyName": "TechCorp",
        "budget": 16650,
        "employeeCapacity": 2
      },
      {
        "id": 1704467200003,
        "projectName": "Healthcare Portal",
        "companyName": "MediCare Solutions",
        "budget": 15000,
        "employeeCapacity": 3
      },
      {
        "id": 1704467200004,
        "projectName": "Analytics Dashboard",
        "companyName": "DataViz Inc",
        "budget": 7900,
        "employeeCapacity": 1
      },
      {
        "id": 1704467200005,
        "projectName": "CRM System",
        "companyName": "SalesPro",
        "budget": 10000,
        "employeeCapacity": 2
      }
    ],
    "employees": [
      {
        "id": 1704467300001,
        "name": "John",
        "surname": "Smith",
        "dob": "1997-03-15",
        "position": "Junior",
        "salary": 3750,
        "assignments": [
          {
            "projectId": 1704467200001,
            "capacity": 1,
            "fit": 0.95
          }
        ]
      },
      {
        "id": 1704467300002,
        "name": "Sarah",
        "surname": "Johnson",
        "dob": "1993-07-22",
        "position": "Middle",
        "salary": 5400,
        "assignments": [
          {
            "projectId": 1704467200001,
            "capacity": 1,
            "fit": 1
          }
        ]
      },
      {
        "id": 1704467300003,
        "name": "Michael",
        "surname": "Williams",
        "dob": "1990-11-08",
        "position": "Senior",
        "salary": 7100,
        "assignments": [
          {
            "projectId": 1704467200001,
            "capacity": 1,
            "fit": 1
          }
        ]
      },
      {
        "id": 1704467300004,
        "name": "Emily",
        "surname": "Brown",
        "dob": "1996-05-30",
        "position": "Middle",
        "salary": 5150,
        "assignments": [
          {
            "projectId": 1704467200002,
            "capacity": 1,
            "fit": 0.9
          }
        ]
      },
      {
        "id": 1704467300005,
        "name": "David",
        "surname": "Jones",
        "dob": "1984-09-12",
        "position": "Lead",
        "salary": 7900,
        "assignments": [
          {
            "projectId": 1704467200002,
            "capacity": 1,
            "fit": 1
          }
        ]
      },
      {
        "id": 1704467300006,
        "name": "Jessica",
        "surname": "Garcia",
        "dob": "1998-01-25",
        "position": "Junior",
        "salary": 4000,
        "assignments": [
          {
            "projectId": 1704467200003,
            "capacity": 0.5,
            "fit": 0.85
          }
        ]
      },
      {
        "id": 1704467300007,
        "name": "Robert",
        "surname": "Martinez",
        "dob": "1987-04-17",
        "position": "Senior",
        "salary": 7350,
        "assignments": [
          {
            "projectId": 1704467200003,
            "capacity": 1,
            "fit": 1
          }
        ]
      },
      {
        "id": 1704467300008,
        "name": "Lisa",
        "surname": "Anderson",
        "dob": "1994-12-03",
        "position": "Middle",
        "salary": 5600,
        "assignments": [
          {
            "projectId": 1704467200003,
            "capacity": 1,
            "fit": 0.95
          }
        ]
      },
      {
        "id": 1704467300009,
        "name": "James",
        "surname": "Taylor",
        "dob": "1980-06-20",
        "position": "Architect",
        "salary": 9150,
        "assignments": [
          {
            "projectId": 1704467200004,
            "capacity": 1,
            "fit": 1
          }
        ]
      },
      {
        "id": 1704467300010,
        "name": "Maria",
        "surname": "Thomas",
        "dob": "1999-08-14",
        "position": "Junior",
        "salary": 3850,
        "assignments": [
          {
            "projectId": 1704467200005,
            "capacity": 0.5,
            "fit": 0.8
          }
        ]
      },
      {
        "id": 1704467300011,
        "name": "Daniel",
        "surname": "Moore",
        "dob": "1992-02-28",
        "position": "Middle",
        "salary": 5850,
        "assignments": [
          {
            "projectId": 1704467200005,
            "capacity": 1,
            "fit": 1
          }
        ]
      },
      {
        "id": 1704467300012,
        "name": "Jennifer",
        "surname": "Jackson",
        "dob": "1989-10-05",
        "position": "Senior",
        "salary": 7500,
        "assignments": [
          {
            "projectId": 1704467200003,
            "capacity": 0.5,
            "fit": 1
          }
        ]
      },
      {
        "id": 1704467300013,
        "name": "Christopher",
        "surname": "White",
        "dob": "1995-03-19",
        "position": "Middle",
        "salary": 5350,
        "assignments": []
      },
      {
        "id": 1704467300014,
        "name": "Amanda",
        "surname": "Harris",
        "dob": "1997-11-27",
        "position": "Junior",
        "salary": 3900,
        "assignments": []
      },
      {
        "id": 1704467300015,
        "name": "Matthew",
        "surname": "Martin",
        "dob": "1983-07-09",
        "position": "Lead",
        "salary": 8150,
        "assignments": []
      }
    ]
  },
  "2026-1": {
    "projects": [
      {
        "id": 1704467200001,
        "projectName": "E-Commerce Platform",
        "companyName": "TechCorp",
        "budget": 12500,
        "employeeCapacity": 3
      },
      {
        "id": 1704467200002,
        "projectName": "Mobile Banking App",
        "companyName": "TechCorp",
        "budget": 16650,
        "employeeCapacity": 2
      },
      {
        "id": 1704467200003,
        "projectName": "Healthcare Portal",
        "companyName": "MediCare Solutions",
        "budget": 15000,
        "employeeCapacity": 3
      },
      {
        "id": 1704467200004,
        "projectName": "Analytics Dashboard",
        "companyName": "DataViz Inc",
        "budget": 7900,
        "employeeCapacity": 1
      },
      {
        "id": 1704467200005,
        "projectName": "CRM System",
        "companyName": "SalesPro",
        "budget": 10000,
        "employeeCapacity": 2
      }
    ],
    "employees": [
      {
        "id": 1704467300001,
        "name": "John",
        "surname": "Smith",
        "dob": "1997-03-15",
        "position": "Junior",
        "salary": 3750,
        "assignments": [
          {
            "projectId": 1704467200001,
            "capacity": 1,
            "fit": 0.95
          }
        ]
      },
      {
        "id": 1704467300002,
        "name": "Sarah",
        "surname": "Johnson",
        "dob": "1993-07-22",
        "position": "Middle",
        "salary": 5400,
        "assignments": [
          {
            "projectId": 1704467200001,
            "capacity": 1,
            "fit": 1
          }
        ]
      },
      {
        "id": 1704467300003,
        "name": "Michael",
        "surname": "Williams",
        "dob": "1990-11-08",
        "position": "Senior",
        "salary": 7100,
        "assignments": [
          {
            "projectId": 1704467200001,
            "capacity": 1,
            "fit": 1
          }
        ]
      },
      {
        "id": 1704467300004,
        "name": "Emily",
        "surname": "Brown",
        "dob": "1996-05-30",
        "position": "Middle",
        "salary": 5150,
        "assignments": [
          {
            "projectId": 1704467200002,
            "capacity": 1,
            "fit": 0.9
          }
        ]
      },
      {
        "id": 1704467300005,
        "name": "David",
        "surname": "Jones",
        "dob": "1984-09-12",
        "position": "Lead",
        "salary": 7900,
        "assignments": [
          {
            "projectId": 1704467200002,
            "capacity": 1,
            "fit": 1
          }
        ]
      },
      {
        "id": 1704467300006,
        "name": "Jessica",
        "surname": "Garcia",
        "dob": "1998-01-25",
        "position": "Junior",
        "salary": 4000,
        "assignments": [
          {
            "projectId": 1704467200003,
            "capacity": 0.5,
            "fit": 0.85
          }
        ]
      },
      {
        "id": 1704467300007,
        "name": "Robert",
        "surname": "Martinez",
        "dob": "1987-04-17",
        "position": "Senior",
        "salary": 7350,
        "assignments": [
          {
            "projectId": 1704467200003,
            "capacity": 1,
            "fit": 1
          }
        ]
      },
      {
        "id": 1704467300008,
        "name": "Lisa",
        "surname": "Anderson",
        "dob": "1994-12-03",
        "position": "Middle",
        "salary": 5600,
        "assignments": [
          {
            "projectId": 1704467200003,
            "capacity": 1,
            "fit": 0.95
          }
        ]
      },
      {
        "id": 1704467300009,
        "name": "James",
        "surname": "Taylor",
        "dob": "1980-06-20",
        "position": "Architect",
        "salary": 9150,
        "assignments": [
          {
            "projectId": 1704467200004,
            "capacity": 1,
            "fit": 1
          }
        ]
      },
      {
        "id": 1704467300010,
        "name": "Maria",
        "surname": "Thomas",
        "dob": "1999-08-14",
        "position": "Junior",
        "salary": 3850,
        "assignments": [
          {
            "projectId": 1704467200005,
            "capacity": 0.5,
            "fit": 0.8
          }
        ]
      },
      {
        "id": 1704467300011,
        "name": "Daniel",
        "surname": "Moore",
        "dob": "1992-02-28",
        "position": "Middle",
        "salary": 5850,
        "assignments": [
          {
            "projectId": 1704467200005,
            "capacity": 1,
            "fit": 1
          }
        ]
      },
      {
        "id": 1704467300012,
        "name": "Jennifer",
        "surname": "Jackson",
        "dob": "1989-10-05",
        "position": "Senior",
        "salary": 7500,
        "assignments": [
          {
            "projectId": 1704467200003,
            "capacity": 0.5,
            "fit": 1
          }
        ]
      },
      {
        "id": 1704467300013,
        "name": "Christopher",
        "surname": "White",
        "dob": "1995-03-19",
        "position": "Middle",
        "salary": 5350,
        "assignments": []
      },
      {
        "id": 1704467300014,
        "name": "Amanda",
        "surname": "Harris",
        "dob": "1997-11-27",
        "position": "Junior",
        "salary": 3900,
        "assignments": []
      },
      {
        "id": 1704467300015,
        "name": "Matthew",
        "surname": "Martin",
        "dob": "1983-07-09",
        "position": "Lead",
        "salary": 8150,
        "assignments": []
      }
    ]
  },
  "2026-3": {
    "projects": [
      {
        "id": 1704467200001,
        "projectName": "E-Commerce Platform",
        "companyName": "TechCorp",
        "budget": 12500,
        "employeeCapacity": 3
      },
      {
        "id": 1704467200002,
        "projectName": "Mobile Banking App",
        "companyName": "TechCorp",
        "budget": 16650,
        "employeeCapacity": 2
      },
      {
        "id": 1704467200003,
        "projectName": "Healthcare Portal",
        "companyName": "MediCare Solutions",
        "budget": 15000,
        "employeeCapacity": 3
      },
      {
        "id": 1704467200004,
        "projectName": "Analytics Dashboard",
        "companyName": "DataViz Inc",
        "budget": 7900,
        "employeeCapacity": 1
      },
      {
        "id": 1704467200005,
        "projectName": "CRM System",
        "companyName": "SalesPro",
        "budget": 10000,
        "employeeCapacity": 2
      }
    ],
    "employees": [
      {
        "id": 1704467300001,
        "name": "John",
        "surname": "Smith",
        "dob": "1997-03-15",
        "position": "Junior",
        "salary": 3750,
        "assignments": [
          {
            "projectId": 1704467200001,
            "capacity": 1,
            "fit": 0.95
          }
        ],
        "vacationDays": []
      },
      {
        "id": 1704467300002,
        "name": "Sarah",
        "surname": "Johnson",
        "dob": "1993-07-22",
        "position": "Middle",
        "salary": 5400,
        "assignments": [
          {
            "projectId": 1704467200001,
            "capacity": 1,
            "fit": 1
          }
        ],
        "vacationDays": []
      },
      {
        "id": 1704467300003,
        "name": "Michael",
        "surname": "Williams",
        "dob": "1990-11-08",
        "position": "Senior",
        "salary": 7100,
        "assignments": [
          {
            "projectId": 1704467200001,
            "capacity": 1,
            "fit": 1
          }
        ],
        "vacationDays": []
      },
      {
        "id": 1704467300004,
        "name": "Emily",
        "surname": "Brown",
        "dob": "1996-05-30",
        "position": "Middle",
        "salary": 5150,
        "assignments": [
          {
            "projectId": 1704467200002,
            "capacity": 1,
            "fit": 0.9
          }
        ],
        "vacationDays": []
      },
      {
        "id": 1704467300005,
        "name": "David",
        "surname": "Jones",
        "dob": "1984-09-12",
        "position": "Lead",
        "salary": 7900,
        "assignments": [
          {
            "projectId": 1704467200002,
            "capacity": 1,
            "fit": 1
          }
        ],
        "vacationDays": []
      },
      {
        "id": 1704467300006,
        "name": "Jessica",
        "surname": "Garcia",
        "dob": "1998-01-25",
        "position": "Junior",
        "salary": 4000,
        "assignments": [
          {
            "projectId": 1704467200003,
            "capacity": 0.5,
            "fit": 0.85
          }
        ],
        "vacationDays": []
      },
      {
        "id": 1704467300007,
        "name": "Robert",
        "surname": "Martinez",
        "dob": "1987-04-17",
        "position": "Senior",
        "salary": 7350,
        "assignments": [
          {
            "projectId": 1704467200003,
            "capacity": 1,
            "fit": 1
          }
        ],
        "vacationDays": []
      },
      {
        "id": 1704467300008,
        "name": "Lisa",
        "surname": "Anderson",
        "dob": "1994-12-03",
        "position": "Middle",
        "salary": 5600,
        "assignments": [
          {
            "projectId": 1704467200003,
            "capacity": 1,
            "fit": 0.95
          }
        ],
        "vacationDays": []
      },
      {
        "id": 1704467300009,
        "name": "James",
        "surname": "Taylor",
        "dob": "1980-06-20",
        "position": "Architect",
        "salary": 9150,
        "assignments": [
          {
            "projectId": 1704467200004,
            "capacity": 1,
            "fit": 1
          }
        ],
        "vacationDays": []
      },
      {
        "id": 1704467300010,
        "name": "Maria",
        "surname": "Thomas",
        "dob": "1999-08-14",
        "position": "Junior",
        "salary": 3850,
        "assignments": [
          {
            "projectId": 1704467200005,
            "capacity": 0.5,
            "fit": 0.8
          }
        ],
        "vacationDays": []
      },
      {
        "id": 1704467300011,
        "name": "Daniel",
        "surname": "Moore",
        "dob": "1992-02-28",
        "position": "Middle",
        "salary": 5850,
        "assignments": [
          {
            "projectId": 1704467200005,
            "capacity": 1,
            "fit": 1
          }
        ],
        "vacationDays": []
      },
      {
        "id": 1704467300012,
        "name": "Jennifer",
        "surname": "Jackson",
        "dob": "1989-10-05",
        "position": "Senior",
        "salary": 7500,
        "assignments": [
          {
            "projectId": 1704467200003,
            "capacity": 0.5,
            "fit": 1
          }
        ],
        "vacationDays": []
      },
      {
        "id": 1704467300013,
        "name": "Christopher",
        "surname": "White",
        "dob": "1995-03-19",
        "position": "Middle",
        "salary": 5350,
        "assignments": [],
        "vacationDays": []
      },
      {
        "id": 1704467300014,
        "name": "Amanda",
        "surname": "Harris",
        "dob": "1997-11-27",
        "position": "Junior",
        "salary": 3900,
        "assignments": [],
        "vacationDays": []
      },
      {
        "id": 1704467300015,
        "name": "Matthew",
        "surname": "Martin",
        "dob": "1983-07-09",
        "position": "Lead",
        "salary": 8150,
        "assignments": [],
        "vacationDays": []
      }
    ]
  }
}